// @ts-check
import { normalize, Schema, arrayOf } from 'normalizr';
import api from 'utils/api';
import moment from 'moment';

const referralProfileSchema = new Schema('referralProfiles', { idAttribute: 'id' });
const providerSchema = new Schema('providers', { idAttribute: 'id' });
const locationSchema = new Schema('locations', { idAttribute: 'id' });
const matchingResultSchema = new Schema('matchingResults', { idAttribute: 'id' });

matchingResultSchema.define({
  provider: providerSchema,
  location: locationSchema,
});

referralProfileSchema.define({
  matchingResults: arrayOf(matchingResultSchema),
});

export function fetchReferralDashboardResults(
  apiEndpoint,
  referralProfileId,
  networkId,
  page,
  searchTerm,
  range,
  specialtyId = null,
  ageClassification = null
) {
  const path = `${apiEndpoint}/referral_profiles/${referralProfileId}/referral_dashboard.json`;
  const params = {
    page,
    range,
    specialty_id: specialtyId,
    search_term: searchTerm,
    age_classification: ageClassification,
    network_id: networkId,
  };
  return api.get(path, { params }).then(response => {
    const data = response.data;

    const { entities } = normalize(data, referralProfileSchema);
    // Assumes that API will send the referralProfile's specialtyId, ageClassification, and range (search radius)
    const resultSpecialtyId = specialtyId || data.specialtyId;
    const resultAgeClassification = ageClassification || data.ageClassification;
    const resultRange = range || data.range;

    return {
      entities,
      totalPages: data.totalPages,
      resultSpecialtyId,
      resultAgeClassification,
      resultRange,
      responseTime: response.time,
      network: data.network,
      organizationReferralRejected: data.organizationReferralRejected,
    };
  });
}

/**
 * @param {string} apiEndpoint
 * @param {string} calendarStart
 * @param {number} days
 * @param {string} referralProfileId
 * @param {string} resultId
 */
export function fetchPageSlotsForResult(
  apiEndpoint,
  calendarStart,
  days,
  referralProfileId,
  resultId
) {
  const newCalendarStart = moment(calendarStart, 'YYYY-M-D')
    .add(days, 'days')
    .format('YYYY-M-D');
  const path = `${apiEndpoint}/referral_profiles/${referralProfileId}/provider_mappings/${resultId}/appointment_slots.json`;
  const params = {
    start: newCalendarStart,
  };
  return api.get(path, { params });
}
